import React from "react";
import MalattiaRaraTemplate from "../../components/malattia-rara/MalattiaRaraTemplate";
import image1 from "../../assets/amiloidosi_cardiaca.png";
const AmiloidosiCardiacaPage: React.FC = () => (
  <MalattiaRaraTemplate
    titolo="Amiloidosi Cardiaca"
    descrizione={[
      "Le amiloidosi sono malattie sistemiche causate dall’errato ripiegamento delle proteine, che porta alla formazione e deposizione di fibrille amiloidi insolubili nello spazio extracellulare di diversi organi. Tra questi, il cuore è uno dei più frequentemente colpiti nelle forme sistemiche, e il suo coinvolgimento rappresenta un fattore chiave nella prognosi della malattia, ancora oggi caratterizzata da elevata morbilità e mortalità.",
      "Attualmente, oltre il 98% dei casi di amiloidosi cardiaca diagnosticati sono dovuti alla deposizione di fibrille amiloidi originate dalle catene leggere delle immunoglobuline (AL) o dalla transtiretina (ATTR), una proteina di trasporto sintetizzata principalmente dal fegato. Negli ultimi dieci anni, i progressi nelle tecniche di imaging cardiaco non invasivo hanno rivoluzionato la diagnosi dell’amiloidosi cardiaca, mentre la ricerca farmacologica ha reso disponibili nuove terapie per le forme AL e ATTR.",
      "Il trattamento dell’amiloidosi cardiaca ATTR si avvale di terapie disease-modifying, con il cardiologo come figura di riferimento sia per la prescrizione sia per la gestione clinica del paziente. Le opzioni terapeutiche attualmente disponibili includono gli stabilizzatori della transtiretina (come il tafamidis) e i silenziatori genici (inotersen, patisiran e vutrisiran), che hanno significativamente migliorato l’outcome dei pazienti.",
      "Una diagnosi precoce, un accurato inquadramento della malattia e l’impiego di terapie mirate possono modificare il decorso di questa rara patologia cardiovascolare.",
    ]}
    immagineDescrizione={image1}
    altImmagineDescrizione="Cuore con depositi di amiloide nel tessuto miocardico"
    sintomi={[
      "Insufficienza cardiaca con dispnea da sforzo e ortopnea",
      "Edema periferico (gonfiore agli arti inferiori)",
      "Affaticamento e debolezza",
      "Sincope o presincope",
      "Dolore toracico",
      "Palpitazioni e aritmie (in particolare fibrillazione atriale)",
      "Ipotensione ortostatica",
      "Sintomi extracardiaci nelle forme sistemiche: macroglossia, porpora periorbitaria, sindrome del tunnel carpale, neuropatia periferica, disturbi gastrointestinali",
      "Proteinuria e insufficienza renale (nelle forme sistemiche)",
    ]}
    diagnosi={[
      'Ecocardiogramma: ispessimento delle pareti ventricolari con aspetto "granular sparkling", disfunzione diastolica, versamento pericardico, ridotto strain longitudinale con risparmio apicale',
      "Risonanza magnetica cardiaca (RMC): enhancement tardivo subendocardico diffuso",
      "Scintigrafia con traccianti ossei (99mTc-PYP, 99mTc-DPD): elevata captazione miocardica nelle forme TTR",
      "Elettrocardiogramma (ECG): bassi voltaggi nonostante l'ipertrofia, pattern pseudoinfartuale",
      "Biomarcatori cardiaci: elevati livelli di troponina e NT-proBNP",
      "Biopsia endomiocardica: gold standard per la diagnosi, con colorazione rosso Congo e birifrangenza verde mela alla luce polarizzata",
      "Screening per discrasie plasmacellulari: elettroforesi e immunofissazione su siero e urine, dosaggio delle catene leggere libere (nelle forme AL)",
      "Test genetico: per identificare mutazioni nel gene TTR nelle forme ereditarie",
    ]}
    trattamento={[
      "Terapia specifica per il tipo di amiloidosi:",
      "- Amiloidosi AL: chemioterapia, inibitori del proteasoma, immunomodulatori, anticorpi monoclonali, trapianto di cellule staminali",
      "- Amiloidosi TTR ereditaria: stabilizzatori della transtiretina (tafamidis, diflunisal), silenziatori genici (patisiran, inotersen)",
      "- Amiloidosi TTR wild-type: tafamidis",
      "Terapia di supporto per l'insufficienza cardiaca: diuretici (con cautela), dosaggi ridotti di beta-bloccanti e ACE-inibitori",
      "Gestione delle aritmie: anticoagulanti per la fibrillazione atriale, pacemaker se necessario",
      "Evitare calcio-antagonisti, digossina ad alte dosi e alcuni FANS",
      "Trapianto cardiaco in casi selezionati (spesso in combinazione con trapianto di fegato nelle forme TTR ereditarie)",
      "Supporto psicologico e terapia occupazionale",
      "Consulenza genetica per le forme ereditarie",
    ]}
    immagineTrattamento="https://via.placeholder.com/400x300"
    altImmagineTrattamento="Trattamento dell'amiloidosi cardiaca"
    epidemiologia={{
      prevalenza:
        "Sconosciuta con precisione, stimata in 1 caso ogni 100.000 nella popolazione generale",
      incidenza:
        "Circa 10-14 casi per milione di persone/anno per l'amiloidosi AL",
      etaMedia: "60-70 anni (TTR wild-type), 50-60 anni (AL e TTR ereditaria)",
      rapportoSessi: "M:F = 1.5:1 (AL), M:F = 3:1 (TTR wild-type)",
    }}
    riferimenti={[
      {
        nome: "Garcia-Pavia P, et al. Diagnosis and treatment of cardiac amyloidosis: a position statement of the ESC Working Group on Myocardial and Pericardial Diseases. Eur Heart J. 2021",
        link: "https://www.esempio.it/riferimento1",
      },
      {
        nome: "Quarta CC, et al. Cardiac amyloidosis. Circulation. 2020",
        link: "https://www.esempio.it/riferimento2",
      },
      {
        nome: "Amyloidosis Foundation - Organizzazione dedicata alla ricerca e supporto dei pazienti",
        link: "https://www.esempio.it/riferimento3",
      },
      {
        nome: "Orphanet - Informazioni sull'Amiloidosi Cardiaca",
        link: "https://www.esempio.it/riferimento4",
      },
    ]}
  />
);

export default AmiloidosiCardiacaPage;
